module.exports = __webpack_public_path__ + "img/02_troll.463b6d92.png";